<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <div class="login_form_type2">
          <h2 class="logo mb-25"><v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img></h2>
          <h3 class="out_title mb-35">{{title}}</h3>
          <v-tabs
            linght
            hide-slider
            flat
            class="tab_type_02"
          >
            <v-tab @click="title=$t('signin.forgot_id.title')">{{ $t('signin.forgot_id.title') }}</v-tab>
            <v-tab @click="title=$t('signin.forgot_pass.title')">{{ $t('signin.forgot_pass.title') }}</v-tab>

            <v-tab-item>
              <v-form
                v-model="valid_tab1"
                lazy-validation
                data-vv-scope="scope_tab1"
              >
                <v-card class="login_form" flat>
                  <h2 class="top_title mt-40">{{ $t('signin.forgot_id.fields.personal_information') }}</h2>
                  <v-card-text class="pa-0 mt-25">
                    <v-row class="ma-0">
                      <!-- English Name -->
                      <v-col cols="12" class="pa-0 mb-25">
                        <h2 class="title mb--5"><i style="color: #a01c2a">*</i> {{ $t('signin.forgot_id.fields.english_name') }}</h2>
                        <v-text-field
                            label=""
                            :placeholder="$t('signin.forgot_id.fields.english_name')"
                            solo
                            flat
                            dense
                            outlined
                            clearable
                            class="login_text_filed type2"
                            append-icon="mdi-alert"
                            v-model="name_en"
                            v-validate="{required: true}"
                            :error-messages="errors.collect('scope_tab1.english_name')"
                            name="english_name"
                            :data-vv-as="$t('signin.forgot_id.fields.english_name')"
                        ></v-text-field>
                      </v-col>
                      <!-- Arabic Name -->
                      <v-col cols="12" class="pa-0 mb-25">
                        <h2 class="title mb--5"><i style="color: #a01c2a">*</i> {{ $t('signin.forgot_id.fields.arabic_name') }}</h2>
                        <v-text-field
                            label=""
                            :placeholder="$t('signin.forgot_id.fields.arabic_name')"
                            solo
                            flat
                            dense
                            outlined
                            clearable
                            class="login_text_filed type2"
                            v-model="name_ar"
                            append-icon="mdi-alert"
                            v-validate="{required: true}"
                            :error-messages="errors.collect('scope_tab1.arabic_name')"
                            name="arabic_name"
                            :data-vv-as="$t('signin.forgot_id.fields.arabic_name')"
                        ></v-text-field>
                      </v-col>

                      <!-- Personal Identify No. or Company Registration No. -->
                      <v-col cols="12" class="pa-0 mb-25">
                        <h2 class="title mb--5 "><i style="color: #a01c2a">*</i> {{ $t('signin.forgot_id.fields.identify_no') }}</h2>
                        <v-text-field
                            label=""
                            :placeholder="$t('signin.forgot_id.fields.identify_no')"
                            solo
                            flat
                            dense
                            outlined
                            class="login_text_filed type2"
                            v-model="identify_no"
                            append-icon="mdi-alert"
                            v-validate="{required: true}"
                            :error-messages="errors.collect('scope_tab1.identify_no')"
                            name="identify_no"
                            :data-vv-as="$t('signin.forgot_id.fields.identify_no')"
                        ></v-text-field>
                      </v-col>

                    </v-row>
                  </v-card-text>
                  <v-card-actions class="pa-0 mt-15">
                    <v-btn color="white" class="sign_in_btn type2" text @click="fnFindEmailID()">{{ $t('signin.forgot_id.fields.find_email') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-tab-item>

            <v-tab-item>
              <v-form
                v-model="valid_tab2"
                lazy-validation
                data-vv-scope="scope_tab2"
              >
                <v-card class="login_form" flat>
                  <h2 class="top_title mt-40">{{ $t('signin.forgot_pass.title') }}</h2>
                  <v-card-text class="pa-0 mt-25">
                    <v-row class="ma-0">
                      <!-- E-mail -->
                      <v-col cols="12" class="pa-0 mb-15">
                        <h2 class="title"><i style="color: #a01c2a">*</i> {{ $t('signin.forgot_pass.fields.email') }}</h2>
                        <v-text-field
                            label=""
                            placeholder=""
                            solo
                            flat
                            dense
                            outlined
                            append-icon="mdi-alert"
                            class="login_text_filed type2 email"
                            v-validate="'required|email'"
                            v-model="email"
                            :error-messages="errors.collect('scope_tab2.email')"
                            :data-vv-as="$t('signin.forgot_pass.fields.email')"
                            name="email"
                            required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="pa-0 mt-15">
                    <v-btn color="white" class="sign_in_btn type2" text :loading="isActiveBtn" @click="fnResetPasswd()">{{ $t('signin.forgot_pass.fields.reset_pass') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'

export default {
  components: {
  },
  data () {
    return {
      title :'Forgot My e-mail ID',

      valid_tab1 :true,
      valid_tab2 :true,

      name_en : '',
      name_ar : '',
      identify_no : '',

      isActiveBtn : false,
      email: '',
    }
  },
  created () {
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    fnFindEmailID() {
      this.$validator.validateAll('scope_tab1').then((result) => {
        if(result){

          let params = {
            name_en : this.name_en,
            name_ar : this.name_ar,
            identify_no : this.identify_no
          }

          requestApi({
            url: '/autho/find/id',
            method: 'POST',
            data: params,
            callback: (res) => {
              if(res.res_code == '200'){
                let option = {
                  text : (this.$i18n.locale === 'en') ? res.res_msg_en : res.res_msg_ar,
                  timeout : 5000
                }
                eventBus.$emit('SHOW_SNACKBAR', option)

              }else{
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          })
        }
      })
    },

    fnResetPasswd(){
      this.$validator.validateAll('scope_tab2').then((result) => {
        if(result){

          this.isActiveBtn = true

          let params = {
            email : this.email
          }

          requestApi({
            url: '/autho/resetpassword',
            method: 'POST',
            data: params,
            callback: (res) => {
              let option = {
                text : (this.$vuetify.rtl) ? res.res_msg_ar : res.res_msg_en,
                timeout : 5000
              }
              eventBus.$emit('SHOW_SNACKBAR', option)
              this.isActiveBtn = false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
